import { render, staticRenderFns } from "./ModalManufacturer.vue?vue&type=template&id=37e5d246&scoped=true"
import script from "./ModalManufacturer.vue?vue&type=script&lang=js"
export * from "./ModalManufacturer.vue?vue&type=script&lang=js"
import style0 from "./ModalManufacturer.vue?vue&type=style&index=0&id=37e5d246&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37e5d246",
  null
  
)

export default component.exports